import { Experties } from '../../../../../store/workspace/types';
import { EditIcon, TrashIcon } from '../../../../../assets/icons/common';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';
import { useRecordDialogs } from '../../hooks/useRecordDialogs';
import { useProfileUpdate } from '../../hooks/useProfileUpdate';
import AddButton from '../../components/AddButton';
import InfoCard from '../../components/InfoCard';
import { MAX_EXPERTISE } from '../../constants';
import ExpertiseForm from './ExpertiseForm';
import styles from './style.module.scss';

const byOrder = (a: Experties, b: Experties) => a.expert.orderId - b.expert.orderId;

/** Lists the applicant's areas of expertise with the skills filed under each of them. */
function Expertise() {
    const { profile, isSaving, saveProfile } = useProfileUpdate();
    const dialogs = useRecordDialogs<Experties>();

    const records = profile?.experties;
    const sorted = [...(records || [])].sort(byOrder);
    const hasRoom = Boolean(records) && sorted.length < MAX_EXPERTISE;

    const deleteRecord = async () => {
        if (!records || !dialogs.deleting) return;
        const saved = await saveProfile({
            experties: records.filter(i => i.expert.id !== dialogs.deleting?.expert.id),
        });

        if (saved) dialogs.cancelDelete();
    };

    return (
        <div className={styles.wrapper}>
            {sorted.map(item => <InfoCard
                layout='inline'
                key={item.expert.title}
                title={item.expert.title}
                actions={<>
                    <EditIcon onClick={() => dialogs.openEditForm(item)} />
                    <TrashIcon onClick={() => dialogs.askToDelete(item)} />
                </>}
            >
                {item.skills.map(skill => <span key={skill.id}>{skill.title}</span>)}
            </InfoCard>)}

            <AddButton
                text='+ Add expertise'
                disabled={!hasRoom}
                onClick={dialogs.openAddForm}
            />

            {dialogs.isFormOpen && <ExpertiseForm
                expertise={dialogs.editing}
                onClose={dialogs.closeForm}
            />}

            {dialogs.deleting && <ConfirmDeleteModal
                loading={isSaving}
                title='Delete expertise'
                onConfirm={deleteRecord}
                onCancel={dialogs.cancelDelete}
                question={`Are you sure you want to delete "${dialogs.deleting.expert.title}" ?`}
            />}
        </div>
    );
};

export default Expertise;
